/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

function plural(n: number): number {
  return 5;
}

export default [
  'km',
  [
    ['a', 'p'],
    ['AM', 'PM'],
  ],
  [
    ['AM', 'PM'],
    ,
  ],
  [
    ['អ', 'ច', 'អ', 'ព', 'ព', 'ស', 'ស'],
    [
      'អាទិត្យ', 'ច័ន្ទ', 'អង្គារ', 'ពុធ',
      'ព្រហស្បតិ៍', 'សុក្រ', 'សៅរ៍'
    ],
    , ['អា', 'ច', 'អ', 'ពុ', 'ព្រ', 'សុ', 'ស']
  ],
  ,
  [
    ['ម', 'ក', 'ម', 'ម', 'ឧ', 'ម', 'ក', 'ស', 'ក', 'ត', 'វ', 'ធ'],
    [
      'មករា', 'កុម្ភៈ', 'មីនា', 'មេសា', 'ឧសភា',
      'មិថុនា', 'កក្កដា', 'សីហា', 'កញ្ញា', 'តុលា',
      'វិច្ឆិកា', 'ធ្នូ'
    ],
  ],
  ,
  [
    ['មុន គ.ស.', 'គ.ស.'], ,
    ['មុន​គ្រិស្តសករាជ', 'គ្រិស្តសករាជ']
  ],
  0, [6, 0], ['d/M/yy', 'd MMM y', 'd MMMM y', 'EEEE d MMMM y'],
  ['h:mm a', 'h:mm:ss a', 'h:mm:ss a z', 'h:mm:ss a zzzz'],
  [
    '{1}, {0}',
    ,
    '{1} នៅ​ម៉ោង {0}',
  ],
  [',', '.', ';', '%', '+', '-', 'E', '×', '‰', '∞', 'NaN', ':'],
  ['#,##0.###', '#,##0%', '#,##0.00¤', '#E0'], '៛', 'រៀល​កម្ពុជា', plural
];
